export const enum RouteStartType {
  HEALTHCARE_FACILITY = 'HEALTHCARE_FACILITY',

  VILLAGE = 'VILLAGE',
}
